import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const nonprofitActivateSubscriptions = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${API_URL}/nonprofits/activate-subscription/`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Nonprofit activate subscriptions error:", error.response);
      throw error;
    }
  }
};

export const nonprofitSubscriptionUpdate = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${API_URL}/nonprofits/subscriptions/update/`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Error is:", error);
      throw error;
    }
  }
};

export const getNonprofitSubscription = async (nonprofitId) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };

    const response = await axios.get(
      `${API_URL}/nonprofits/activate-subscription/${nonprofitId}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Get nonprofit subscriptions error:", error.response);
      throw error;
    }
  }
};

export const updateNonProfitSubscription = async (nonprofitId) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };

    const response = await axios.patch(
      `${API_URL}/nonprofits/activate-subscription/${nonprofitId}/update/`,
      config
    );

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      throw error;
    }
  }
};